import api from ".";
import { getToken } from "../Auth/Token";

export const getUnassignedWorkOrders = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/unassignedWorkOrders", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Unassigned Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

// api to get hold work orders
export const getOnHoldWorkOrders = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/onholdWorkOrders", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("On Hold Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getAllWorkOrders = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/allWorkOrders", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("All Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getIncompleteWorkOrders = async (options = {}) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/incompleteWorkOrders", {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
    });
    return res;
  } catch (error) {
    console.error("All Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getAllWorkOrdersByRoom = async (room, startDate, endDate) => {
  try {
    const token = getToken();
    const res = await api.get(
      `/api/workOrder/allWorkOrders?room=${encodeURIComponent(
        room,
      )}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("getAllWorkOrdersByRoom API Error:", {
      room,
      startDate,
      endDate,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const assignRoom = async (workOrderId, room, assignedDate) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/assignRoom/${workOrderId}`,
      { room, assignedDate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Assign Room API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const mirrorKpiPlannedQty = async (
  workOrderId,
  source = "plannedQty",
) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/mirrorKpiPlannedQty/${workOrderId}`,
      { source },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Mirror KPI Planned Qty API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const lockKpiQty = async (workOrderId) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/lockKpiQty/${workOrderId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Lock KPI Qty API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const unlockKpiQty = async (workOrderId) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/unlockKpiQty/${workOrderId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Unlock KPI Qty API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const reorderWorkOrders = async (
  room,
  date,
  orderedWorkOrderIdsOrItems,
) => {
  try {
    const token = getToken();

    if (
      !Array.isArray(orderedWorkOrderIdsOrItems) ||
      orderedWorkOrderIdsOrItems.length === 0
    ) {
      throw new Error("orderedWorkOrderIds must be a non-empty array");
    }

    const isOrderedItems =
      typeof orderedWorkOrderIdsOrItems[0] === "object" &&
      orderedWorkOrderIdsOrItems[0] !== null;

    const res = await api.post(
      "/api/workOrder/reorder",
      {
        room,
        date,
        ...(isOrderedItems
          ? { orderedItems: orderedWorkOrderIdsOrItems }
          : { orderedWorkOrderIds: orderedWorkOrderIdsOrItems }),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Reorder Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });

    if (error.response?.status === 400) {
      throw new Error(
        error.response.data?.error ||
          "Invalid reorder request (missing IDs or mismatch)",
      );
    }
    if (error.response?.status === 404) {
      throw new Error("Room or work orders not found");
    }

    throw error;
  }
};

export const getCleaningTaskConfig = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/cleaningTaskConfig", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Get Cleaning Task Config API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const updateCleaningTaskConfig = async (payload) => {
  try {
    const token = getToken();
    const res = await api.put("/api/workOrder/cleaningTaskConfig", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Update Cleaning Task Config API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const addCleaningTaskToSchedule = async (
  room,
  date,
  taskType,
  options = {},
) => {
  try {
    const token = getToken();
    const res = await api.post(
      "/api/workOrder/addCleaningTask",
      { room, date, taskType, ...options },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Add Cleaning Task API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const renameCleaningTaskInSchedule = async (taskId, title) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/cleaningTask/${taskId}`,
      { title },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Rename Cleaning Task API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const removeCleaningTaskFromSchedule = async (taskId) => {
  try {
    const token = getToken();
    const res = await api.delete(`/api/workOrder/cleaningTask/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Remove Cleaning Task API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const QCLABhold = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/holds", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("QCLAB Hold Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createTransfer = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/workOrder/createTransfer", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Create Transfer API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};


export const syncTransfersToShopify = async (transfers) => {
  try {
    const token = getToken();
    const res = await api.post(
      "/api/workOrder/sync-shopify",  
      { transfers },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Sync to Shopify API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error?.response?.data?.error || error.message || "Failed to sync transfers to Shopify";
  }
};


export const updateTransfer = async (payload) => {
  try {
    const token = getToken();
    const res = await api.put("/api/workOrder/updateTransfer", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Update Transfer API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getTransfer = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/getTransfer", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Get Transfers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const historicalTransfer = async (date, syncStatus) => {
  try {
    const token = getToken();
    const params = {};
    if (date) {
      params.startDate = date;
      params.endDate = date;
    }
    if (syncStatus === "synced" || syncStatus === "not_synced") {
      params.syncStatus = syncStatus;
    }
    const res = await api.get("/api/workOrder/historicalTransfer", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params,
    });
    return res;
  } catch (error) {
    console.error("Historical Transfers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const updateWarehouse = async (workOrderId, warehouse) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/updateWarehouse/${workOrderId}`,
      {
        warehouse,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Update Warehouse API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const releaseWorkOrder = async (orders) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/releaseWorkOrders`,
      {
        orders,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Release Work Order API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const updateWorkOrderStatus = async (workOrderId, status) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/updateStatus/${workOrderId}`,
      {
        status,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Update Work Order Status API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const splitWorkOrder = async (workOrderId, splitQuantity, assignedDate) => {
  try {
    const token = getToken();
    const res = await api.post(
      `/api/workOrder/splitWorkOrder/${workOrderId}`,
      { splitQuantity, assignedDate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Split Work Order API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateAssignedDate = async (workOrderId, assignedDate) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/updateAssignedDate/${workOrderId}`,
      {
        assignedDate,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Update Assigned Date API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const syncFromErpag = async (payload = {}) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/sync-from-erpag", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error("Sync From ERPAG API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createRecurringTask = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/task/createRecurring", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Recurring Task API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const unassignWorkOrder = async (workOrderId) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/unassignedWorkOrder`,
      { workOrderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Unassign Work Order API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createCategory = async (categoryData) => {
  try {
    const token = getToken();
    const res = await api.post("/api/category/createCategory", categoryData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Category API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/category/getCategory", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Categories API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createManageSchedule = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/category/createManageSchedule", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Manage Schedule API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const token = getToken();
    const res = await api.delete(`/api/category/deleteCategory/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Delete Category API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const deleteManageSchedule = async (scheduleId) => {
  try {
    const token = getToken();
    const res = await api.delete(
      `/api/category/deleteManageSchedule/${scheduleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Delete Manage Schedule API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getPermissions = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/auth/getPermission", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Permissions API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createRolePermission = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/auth/createRolePermission", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create Role Permission API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getRolePermissions = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/auth/getRolePermission", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Role Permissions API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getUsers = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/auth/getUsers", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Users API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const createUserPermission = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/auth/createUserPermission", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Create User Permission API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getUserPermission = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/auth/getUserPermission", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get User Permission API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

// api/workOrder.js
export const getProfile = async () => {
  try {
    const token = getToken();
    const res = await api.get(
      `/api/auth/profile`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Get User Permission By User API Error:", error);
    throw error;
  }
};

export const getUserPermissionByUser = async (userId) => {
  try {
    const token = getToken();
    const res = await api.get(
      `/api/auth/getUserPermissionByUser?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Get User Permission By User API Error:", error);
    throw error;
  }
};

export const inviteUser = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/auth/inviteUser", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Invite User API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const token = getToken();

    const res = await api.post(
      "/api/auth/deleteUser",
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error(
      "Delete User API Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const updateProfile = async (payload) => {
  try {
    const token = getToken();
    const res = await api.put("/api/auth/updateProfile", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Update Profile API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const changePassword = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/auth/changePassword", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Change Password API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getProductivityByRoom = async (startDate, endDate) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/productivityByRoom", {
      params: {
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Productivity By Room API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getWorkOrderStats = async (startDate, endDate) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/getWorkOrderStats", {
      params: {
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Work Order Stats API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getKPIWorkOrders = async (room, startDate, endDate) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/getKPIWorkOrders", {
      params: {
        room,
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get KPI Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const lockScheduleKpiBaseline = async (roomName, scheduleDate) => {
  try {
    const token = getToken();
    const res = await api.post(
      "/api/workOrder/lockScheduleKpiBaseline",
      { roomName, scheduleDate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Lock Schedule KPI Baseline API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getCategoriesList = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/getCategories", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Categories API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const token = getToken();
    const res = await api.put(`/api/auth/updateUser/${userId}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });                                                               
    return res.data;
  } catch (error) {
    console.error("Update User API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getDashboardWorkOrders = async (room, startDate, endDate) => {
  try {
    const token = getToken();

    const res = await api.get("/api/workOrder/getDashboardWorkOrders", {
      params: {
        room,
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Get Dashboard Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      url: error.config?.url,
      params: error.config?.params,
    });
    throw error;
  }
};

export const getPostCleaningConfig = async () => {
  try {
    const token = getToken();

    const res = await api.get("/api/workOrder/getPostCleaningConfig", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Get Post Cleaning Config API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      url: error.config?.url,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getPrePostOverride = async (room, date) => {
  try {
    const token = getToken();
    const res = await api.get("/api/workOrder/prePostOverride", {
      params: { room, date },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Pre/Post Override API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const setPrePostOverride = async (payload) => {
  try {
    const token = getToken();
    const res = await api.put("/api/workOrder/prePostOverride", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Set Pre/Post Override API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const refreshWorkOrders = async () => {
  try {
    const token = getToken();

    // Calculate date 7 days ago from today
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 21);

    // Format as YYYY-MM-DD (required by ERPAG API)
    const fromDate = sevenDaysAgo.toISOString().split("T")[0];

    console.log(`Refreshing work orders from ERPAG since: ${fromDate}`);

    const res = await api.get(
      `/api/workOrder/refresh-workorders`,
      {
        params: { fromDate },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Refresh Work Orders API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });

    throw error;
  }
};

export const completeWorkOrder = async (orderId) => {
  try {
    const token = getToken();
    const res = await api.put(
      `/api/workOrder/completeWorkOrder`,
      { id: orderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Complete Work Order API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const markAsCompletedLocally = async (orderId) => {
  try {
    const token = getToken();

    const res = await api.post(
      `/api/workOrder/mark-local-complete`,
      { id: orderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Mark As Completed Locally API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });

    throw error;
  }
};

export const batchUpdateOnlineQty = async (updates) => {
  try {
    const token = getToken();

    if (!Array.isArray(updates) || updates.length === 0) {
      throw new Error("Updates must be a non-empty array");
    }

    console.log("Updating online quantities:", updates);

    const res = await api.post(
      `/api/workOrder/batchonline`,
      { updates },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    console.log("Online quantities updated successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("batchUpdateOnlineQty API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });

    throw error;
  }
};

export const getRoomAllergenPolicies = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/room-allergen-policies", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Get Room Allergen Policies API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateRoomAllergenPolicies = async (roomAllergenPolicies) => {
  try {
    const token = getToken();

    if (!Array.isArray(roomAllergenPolicies)) {
      throw new Error("roomAllergenPolicies must be an array");
    }

    const res = await api.post(
      "/api/room-allergen-policies",
      { roomAllergenPolicies },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Update Room Allergen Policies API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
